/**
 * @flow
 * @relayHash 21632dbc55bc5a80ff1312e3218f60e4
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteCustomerMutationVariables = {|
  id: string
|};
export type DeleteCustomerMutationResponse = {|
  +deleteCustomer: {|
    +id: string
  |}
|};
export type DeleteCustomerMutation = {|
  variables: DeleteCustomerMutationVariables,
  response: DeleteCustomerMutationResponse,
|};
*/


/*
mutation DeleteCustomerMutation(
  $id: String!
) {
  deleteCustomer(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteCustomer",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "CustomerModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteCustomerMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteCustomerMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteCustomerMutation",
    "id": null,
    "text": "mutation DeleteCustomerMutation(\n  $id: String!\n) {\n  deleteCustomer(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '086664fb0e03961dcd81f9b21f3276c8';
module.exports = node;
